import React, { useState, useCallback } from 'react';
import Loader      from './components/Loader';
import Navbar      from './components/Navbar';
import Hero        from './components/Hero';
import Services    from './components/Services';
import About       from './components/About';
import Product     from './components/Product';
import Team        from './components/Team';
import Contact     from './components/Contact';
import Footer      from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  const [loading, setLoading] = useState(true);
  const handleLoaderDone = useCallback(() => setLoading(false), []);

  return (
    <>
      {loading && <Loader onDone={handleLoaderDone} />}
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Product />
        <Team />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}
